export default __webpack_public_path__ + "static/media/pix.7cff8e46.svg";